/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export const Invoice = {
	list(type, page, params) {
		return Ajax.post("/invoice/list/" + type, params, {params: page})
	},
	download(type, params) {
		return Ajax.post("/invoice/list/" + type, params, {responseType: 'blob'})
	},
	save(params) {
		return Ajax.post("/invoice", params)
	},
	remove(ids) {
		return Ajax.delete("/invoice?id=" + ids.join("&id="))
	},
	batchUpdate(invoiceBusinessTypeId, ids) {
		return Ajax.get("/invoice/batch/" + invoiceBusinessTypeId + "?id=" + ids.join("&id="))
	},
	batchCheck(checkDate, ids) {
		return Ajax.get(`/invoice/batch/check?checkDate=${checkDate}&id=` + ids.join("&id="))
	},
	batchRevokeCheck(ids) {
		return Ajax.get(`/invoice/batch/revokeCheck?id=` + ids.join("&id="))
	},
	generateVoucher(rows) {
		return Ajax.post(`/invoice/generate/voucher`, rows)
	},
	import(type, form) {
		return Ajax.post(`/invoice/import/${type}`, form, {'Content-Type': 'multipart/form-data'})
	},
	importNum(type, form) {
		return Ajax.post(`/invoice/importNum/${type}`, form, {'Content-Type': 'multipart/form-data'})
	},
	getTaxRpa(type, params) {
		return Ajax.post('/api/tax-rpa/fetch-invoices/' + type,params)
	},
	submitRpa(taskId,positions) {
		return Ajax.post('/api/tax-rpa/submit-captcha-click',{taskId,positions})
	},
	submitSmsCode(taskId, code) {
		return Ajax.post('/api/tax-rpa/submit-captcha', null, {
			params: { taskId, code }
		});
	},
	// 取消 RPA 任务
	cancelRpaTask() {
		return Ajax.post('/api/tax-rpa/cancel-task');
	},
	// 获取 RPA 任务状态
	getRpaTaskStatus() {
		return Ajax.get('/api/tax-rpa/task-status');
	}
}

export const InvoiceBusiness = {
	list(type) {
		return Ajax.get("/invoice/business", {type})
	},
	save(params) {
		return Ajax.post("/invoice/business", params)
	},
	remove(id) {
		return Ajax.delete("/invoice/business/" + id)
	}
}
